import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

function Login() {
  const navigate = useNavigate();
  const { login, user, isAdmin } = useAuth();
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (user && isAdmin) {
    navigate('/admin');
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const userData = await login(formData.username, formData.password);
      if (userData.role === 'admin') {
        navigate('/admin');
      } else {
        setError('Acesso de administrador necessário');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Falha no login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container" style={{ paddingTop: '80px', paddingBottom: '80px', maxWidth: '420px' }}>
      <div style={{
        padding: '40px',
        background: 'var(--background-secondary)',
        borderRadius: 'var(--radius-lg, 14px)',
        border: '1px solid var(--border, rgba(255,255,255,0.06))'
      }}>
        <h1 style={{ textAlign: 'center', marginBottom: '8px', fontSize: '1.8rem' }}>Entrar</h1>
        <p style={{ textAlign: 'center', color: 'var(--text-secondary)', marginBottom: '32px', fontSize: '0.9rem' }}>Painel de administração</p>

        {error && (
          <div className="message error">{error}</div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Utilizador ou e-mail</label>
            <input
              type="text"
              id="username"
              value={formData.username}
              onChange={(e) => setFormData({ ...formData, username: e.target.value })}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Palavra-passe</label>
            <input
              type="password"
              id="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', padding: '14px' }}
            disabled={loading}
          >
            {loading ? 'A entrar...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
